import { renderToStaticMarkup } from 'react-dom/server';
import PurchaseHistoryDocument from '@/components/PurchaseHistoryDocument';
import { purchaseHistoryStyles } from '@/lib/purchase-history-styles.mjs';
import { goodsPaper } from '@/lib/goods-print.mjs';

export function purchasePrintHtml(purchase, mode = 'detail', paper = 'A5') {
  const document = renderToStaticMarkup(<PurchaseHistoryDocument purchase={purchase} printMode={mode} />);
  return `<!doctype html><html lang="id"><head><meta charset="UTF-8"><title>Dokumen Pembelian</title><style>body{font-family:Arial,sans-serif;color:#111;background:#fff;--masivi-border:#ddd;--masivi-text-muted:#52606d;--masivi-card-bg:#fff;--masivi-background:#f8fafc}${purchaseHistoryStyles}@page{size:${goodsPaper(paper)} landscape;margin:8mm}</style></head><body><div class="ph-print-toolbar"><button onclick="window.print()">Cetak / Simpan PDF</button> <button onclick="window.close()">Tutup</button> ${goodsPaper(paper)} mendatar</div>${document}</body></html>`;
}
export function printPurchaseHistory(purchase, mode, paper = 'A5') {
  const popup = window.open('', '_blank', 'width=1200,height=850');
  if (!popup) return false;
  popup.opener = null;
  popup.document.open(); popup.document.write(purchasePrintHtml(purchase, mode, paper)); popup.document.close();
  popup.focus();
  // The separate document also retains a print button if the native dialog is dismissed.
  popup.setTimeout(() => popup.print(), 150);
  return true;
}
